import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data || {});
        } catch (e) {
            /* silently fall back to defaults in components */
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const get = useCallback(
        (key, fallback = "") => {
            const v = content[key];
            return v !== undefined && v !== null ? v : fallback;
        },
        [content],
    );

    return (
        <ContentContext.Provider value={{ content, loading, get, refresh: load }}>
            {children}
        </ContentContext.Provider>
    );
}

export function useContent() {
    return useContext(ContentContext) || { content: {}, loading: false, get: (k, f) => f, refresh: () => {} };
}
